import { ThemeProvider } from "@mui/material/styles";
import { useContext, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { ConsentContext } from "./context/ConsentContext";
import Routes from "./routes";
import theme from "./theme";

function App() {
    const { consent } = useContext(ConsentContext);
    const location = useLocation();

    function gtag() {
        window.dataLayer.push(arguments);
    }

    useEffect(() => {
        try {
            if (consent && process.env.NODE_ENV === "production") {
                gtag("consent", "update", {
                    analytics_storage: consent.analytics_storage
                        ? "granted"
                        : "denied",
                    ad_storage: consent.ad_storage ? "granted" : "denied",
                    ad_user_data: consent.ad_user_data ? "granted" : "denied",
                    ad_personalization: consent.ad_personalization
                        ? "granted"
                        : "denied",
                    personalization_storage: consent.personalization_storage
                        ? "granted"
                        : "denied",
                    functionality_storage: "granted", // Supposant que cela reste toujours activé
                    security_storage: "granted", // Supposant que cela reste toujours activé
                });
            }
        } catch (error) {
            console.error("Error reading or updating cookie consent:", error);
        }
    }, [consent]);

    useEffect(() => {
        // Suivi de la pageview si le consentement pour les analytics est accordé
        gtag("event", "pageview", {
            page_path: window.location.pathname + window.location.search,
        });
    }, [location]);

    return (
        <ThemeProvider theme={theme}>
            <HelmetProvider>
                <Routes />
            </HelmetProvider>
        </ThemeProvider>
    );
}

export default App;
